// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  AdminAccessTokenStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Helpers
import _ from 'lodash';
import {
  adminAccessTokenStatusLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $Model<'AdminAccessToken'> | $ModelUpsertParams<'AdminAccessToken'>;
};

const AdminAccessTokenFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <Row>
      <Col>
        <AvField
          label={t('Title')}
          name={'Name'}
          required
          value={item.Name}
        />
      </Col>
      <Col>
        <AvField
          label={t('Status')}
          name={'Status'}
          required
          type={'select'}
          value={item.Status}
        >
          {_.map(
            AdminAccessTokenStatus,
            (i) => (
              <option
                key={i}
                value={i}
              >
                {t(adminAccessTokenStatusLabel[i])}
              </option>
            ),
          )}
        </AvField>
      </Col>
    </Row>
  );
};

export default AdminAccessTokenFieldsView;
